import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { finalize } from 'rxjs';
import { UiActions } from '../../store/ui/ui.actions';

/**
 * Set on a request's HttpContext to keep it out of the global loading count
 * (e.g. background polling). Usage: `http.get(url, { context: new HttpContext().set(SKIP_LOADING, true) })`.
 */
export const SKIP_LOADING = new HttpContextToken<boolean>(() => false);

/** Drives the global loader by counting in-flight requests in the ui store slice. */
export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(SKIP_LOADING)) {
    return next(req);
  }

  const store = inject(Store);
  store.dispatch(UiActions.requestStarted());

  return next(req).pipe(finalize(() => store.dispatch(UiActions.requestCompleted())));
};
